import AppContext from "PFApp/app_context";
import { useGrowl } from "PFApp/use_growl";
import { useSession } from "PFApp/use_session";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";

import { PROXIED_ENVS } from "../utilities/routes";

const useInsightsApi = () => {
  const session = useSession();
  const [insightsApiError, setInsightsApiError] = useState(false);
  const {
    store: { currentAccount }
  } = useContext(AppContext);
  const { t } = useTranslation("insights");

  const growl = useGrowl();

  const insightsApi = (path, data) =>
    $.ajax({
      url: `${PF.config.insights_api_endpoint}${path}`,
      headers: {
        profindaapitoken: session.getAccessToken(),
        account: currentAccount.full_domain,
        ...(PROXIED_ENVS.includes(PF.config.environment) ? null : { sessionHost: PF.config.api_endpoint })
      },
      data
    })
      .then((res) => {
        if (res.Error) {
          setInsightsApiError(true);
          return false;
        } else {
          setInsightsApiError(false);
          return res;
        }
      })
      .catch((err) => {
        setInsightsApiError(true);
        growl({
          message: t("error"),
          kind: "error"
        });

        return err;
      });

  return {
    insightsApi,
    insightsApiError
  };
};

export default useInsightsApi;
